var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.63333 18.3333H14.3667C16.6667 18.3333 17.5833 16.925 17.6917 15.2083L18.125 8.325C18.2417 6.525 16.8083 5 15 5C14.4917 5 14.025 4.70833 13.7917 4.25833L13.1917 3.05C12.8083 2.29167 11.8083 1.66667 10.9583 1.66667H9.05C8.19167 1.66667 7.19167 2.29167 6.80833 3.05L6.20833 4.25833C5.975 4.70833 5.50833 5 5 5C3.19167 5 1.75833 6.525 1.875 8.325L2.30833 15.2083C2.40833 16.925 3.33333 18.3333 5.63333 18.3333Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 6.66667H11.25",
    stroke: "#6E6E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 15C11.4917 15 12.7083 13.7833 12.7083 12.2917C12.7083 10.8 11.4917 9.58333 10 9.58333C8.50833 9.58333 7.29167 10.8 7.29167 12.2917C7.29167 13.7833 8.50833 15 10 15Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.35857a4989d6a7072fd1037efbed33fb.svg";
export { ForwardRef as ReactComponent };